import React from "react";

import moment from "moment";

import { SPEC_FLAGS_MAP } from "../../../../../Common/constants/SpecFlagConstants";
import LockedValue from "../../../../../grace-period/components/LockedValue";
import { useAccessStatus } from "../../../../../grace-period/hooks/useAccessStatus";
import { QUADRANT_STYLE_MAP } from "../../Constant";
import { checkPinIsPinned } from "../../pinHelper";
import ReportViewHeader from "../ReportViewHeader";

import { isResultRevealingSpec } from "../../../../../grace-period/utils";

import { ReactComponent as StatusDotIcon } from "../../../../../../assets/images/environment/statusPingDot.svg";

export default function ResultHeader({ report, pin }) {
  const { areResultsLocked } = useAccessStatus();
  if (!report) {
    return null;
  }
  const { color, label } = SPEC_FLAGS_MAP[report.specs_flag] ?? SPEC_FLAGS_MAP.invalid;
  const lockStatus = areResultsLocked && isResultRevealingSpec(report.specs_flag);
  const { color: blockColor } = checkPinIsPinned(pin)
    ? QUADRANT_STYLE_MAP[pin.quadrant]
    : { color: undefined }; // red

  return (
    <div className="env-report-view-report-section-header">
      <ReportViewHeader title="Report" subTitle={report.received_date.length > 0 ? moment(report.received_date).format("DD MMMM YYYY") : "-"} subTitleColor="var(--color-primary)" blockColor={blockColor} />
      <div className="env-report-view-report-section-header-devider" />
      <div className="env-report-view-report-section-header-status-container">
        {lockStatus ? (
          <LockedValue locked />
        ) : (
          <>
            <StatusDotIcon width={25} height={25} fill={color} />
            <span style={{ fontSize: "14px", color }}>
              {label}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
